import React from 'react';
import about_img from "../../assets/banner/about_img.jpg";

const AboutBanner = ({ title, description }) => {
    return (
        <section className="about-header">
            <div className="about-banner">
                <img src={about_img} alt="About Iconic Unity Group" />
                <div className="about-banner-content">
                    <h1 className="about-us-h1">{title}</h1>
                    <p>
                        {description}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default AboutBanner;